/* ============
 * Add Batch Log Component
 * ============
 *
 * This is the component for creating batch log
 */
import { mapGetters, mapMutations } from 'vuex';
import store from './../../store';
import accountService from './../../services/account';

export default {
  data() {
    return {
      info: 'info',
      primary: 'primary',
      group: 'None',
    };
  },
  computed: {
    ...mapGetters({
      account: 'account',
      searchQuery: 'productQuery',
      view: 'getView',
    }),
  },
  created() {
    this.group = this.account.productGrouping;
    store.dispatch('setProductGrouping', this.account.productGrouping);
    if (this.view == 'card') {
      this.info = 'info';
      this.primary = 'primary';
    } else {
      this.primary = 'info';
      this.info = 'primary';
    }
  },

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
      setModalClass: 'SET_MODAL_CLASS',
    }),

    handleGroupByChange(filter) {
      const value = filter !== 'None' ? filter : '';
      const query = { page: 1, limit: 50, search: this.searchQuery.search, grouping: value };
      store.dispatch('setProductQuery', query);
      accountService.updateProductIndexSettings(this.account.userId, { field: 'product_grouping', value });
    },

    changeView(view) {
      if (this.info != view) {
        this.primary = this.info;
        this.info = view;
        if (this.info == 'info') {
          store.dispatch('setView', 'card');
        } else {
          store.dispatch('setView', 'list');
        }
      }
      accountService.updateProductIndexSettings(this.account.userId, {
        field: 'product_display',
        value: this.info == 'info' ? 'card' : 'list',
      });
    },
    /*
    * Closes the modal
    */
    closeModal() {
      this.setModalClass('default');
      this.toggle(false);
      this.unsetModalContent();
    },
  },

};



// WEBPACK FOOTER //
// ./src/app/components/productIndexSettingsPopup/productIndexSettingsPopup.js